module.exports = __webpack_public_path__ + "static/media/DK4055_07.3ad5b858.jpg";